import { exists } from '@/api'

export interface BatchOrderAcceptLedgerConditionListItem {
  rdoOutputType: string
  rdoBranchType: string
  branch: string
  rdoOutputConditionType: string
  traderType: string
  donorType: string
  acceptanceDateFrom: string
  acceptanceDateTo: string
  acceptanceType: string
  collectionType: string
  isAcceptanceSearchBooks: boolean
  isAcceptanceSearchAV: boolean
  isAcceptanceSearchMagazine: boolean
  collectionPeriod: boolean
  collectionNum1From: string
  collectionNum1To: string
  collectionNum2From: string
  collectionNum2To: string
  collectionNum3From: string
  collectionNum3To: string
  collectionNum4From: string
  collectionNum4To: string
  collectionNum5From: string
  collectionNum5To: string
  rdoOrderListOrder: string
  rdoSituationListOutput: string
  ndcDigits: string
  rdoAmountDispType: string
  isOutputAcceptanceDate: boolean
  shelfType: string
  rdoNdc: string
  ndc: string
  rdoAcceptLedgerOutputType: string
  acceptanceLedgerMemo: string
  batchType: string
}

export function BatchOrderAcceptLedgerConditionListItemFromJSON(
  json: any
): BatchOrderAcceptLedgerConditionListItem {
  const resp = JSON.parse(json)

  return {
    rdoOutputType: exists(resp, 'rdo_output_type') ? resp.rdo_output_type : '1',
    rdoBranchType: exists(resp, 'rdo_branch_type') ? resp.rdo_branch_type : '1',
    branch: exists(resp, 'branch') ? resp.branch : '',
    rdoOutputConditionType: exists(resp, 'rdo_output_condition_type')
      ? resp.rdo_output_condition_type
      : '1',
    traderType: exists(resp, 'trader_type') ? resp.trader_type : '',
    donorType: exists(resp, 'donor_type') ? resp.donor_type : '',
    acceptanceDateFrom: exists(resp, 'acceptance_date_from')
      ? resp.acceptance_date_from
      : '',
    acceptanceDateTo: exists(resp, 'acceptance_date_to')
      ? resp.acceptance_date_to
      : '',
    acceptanceType: exists(resp, 'acceptance_type') ? resp.acceptance_type : '',
    collectionType: exists(resp, 'collection_type') ? resp.collection_type : '',
    isAcceptanceSearchBooks: exists(resp, 'is_acceptance_search_books')
      ? resp.is_acceptance_search_books
      : false,
    isAcceptanceSearchAV: exists(resp, 'is_acceptance_search_av')
      ? resp.is_acceptance_search_av
      : false,
    isAcceptanceSearchMagazine: exists(resp, 'is_acceptance_search_magazine')
      ? resp.is_acceptance_search_magazine
      : false,
    collectionPeriod: exists(resp, 'collection_period')
      ? resp.collection_period
      : false,
    collectionNum1From: exists(resp, 'collection_num1_from')
      ? resp.collection_num1_from
      : '',
    collectionNum1To: exists(resp, 'collection_num1_to')
      ? resp.collection_num1_to
      : '',
    collectionNum2From: exists(resp, 'collection_num2_from')
      ? resp.collection_num2_from
      : '',
    collectionNum2To: exists(resp, 'collection_num2_to')
      ? resp.collection_num2_to
      : '',
    collectionNum3From: exists(resp, 'collection_num3_from')
      ? resp.collection_num3_from
      : '',
    collectionNum3To: exists(resp, 'collection_num3_to')
      ? resp.collection_num3_to
      : '',
    collectionNum4From: exists(resp, 'collection_num4_from')
      ? resp.collection_num4_from
      : '',
    collectionNum4To: exists(resp, 'collection_num4_to')
      ? resp.collection_num4_to
      : '',
    collectionNum5From: exists(resp, 'collection_num5_from')
      ? resp.collection_num5_from
      : '',
    collectionNum5To: exists(resp, 'collection_num5_to')
      ? resp.collection_num5_to
      : '',
    rdoOrderListOrder: exists(resp, 'rdo_order_list_order')
      ? resp.rdo_order_list_order
      : '1',
    rdoSituationListOutput: exists(resp, 'rdo_situation_list_output')
      ? resp.rdo_situation_list_output
      : '1',
    ndcDigits: exists(resp, 'ndc_digits') ? resp.ndc_digits : '',
    rdoAmountDispType: exists(resp, 'rdo_amount_disp_type')
      ? resp.rdo_amount_disp_type
      : '1',
    isOutputAcceptanceDate: exists(resp, 'is_output_acceptance_date')
      ? resp.is_output_acceptance_date
      : false,
    shelfType: exists(resp, 'shelf_type') ? resp.shelf_type : '',
    rdoNdc: exists(resp, 'rdo_ndc') ? resp.rdo_ndc : '1',
    ndc: exists(resp, 'ndc') ? resp.ndc : '',
    rdoAcceptLedgerOutputType: exists(resp, 'rdo_accept_ledger_output_type')
      ? resp.rdo_accept_ledger_output_type
      : '1',
    acceptanceLedgerMemo: exists(resp, 'acceptance_ledger_memo')
      ? resp.acceptance_ledger_memo
      : '',
    batchType: resp.batch_type
  }
}
